<template>
    <div
        :id="id"
        class="tl-text-title"
    >
        <div
            class="tl-text-title-content"
            :class="cssClass"
            v-html="markedContent"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import marked from 'widget-components/utilities/marked'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    content: string
    options?: {
        size?: string
        alignment?: string
    }
}>()

const markedContent = computed(() => marked(props.content))
const size = computed(() => props.options?.size?.toLowerCase() || '')
const alignment = computed(() => props.options?.alignment || '')

const cssClass = computed(() => {
    const classes = []

    if (size.value) {
        classes.push(size.value)
    }

    if (alignment.value) {
        classes.push(alignment.value)
    }

    return classes.join(' ')
})
</script>

<style lang="sass" scoped>
@import "./TextTitle.sass"
</style>
